<script setup lang="ts">
import { formatIsoDate } from "~/core/utils/date";
import { NO_CONTENT, PATH_DTWINS_ID } from "~/modules/dtwin/constants";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import ILxcArrowRightCircle from "~icons/lxc/arrow-right-circle";

const props = defineProps<{
  dtwin: Dtwin;
  modelLabel: string;
}>();

const { t } = useI18n();
const dateFormat: string = t("dateFormat.datetime");

const router = useRouter();

const latLongRepresentation = computed(() => {
  let value = NO_CONTENT;
  if (
    props.dtwin.features?.location?.reported?.latitude !== undefined &&
    props.dtwin.features?.location?.reported?.longitude !== undefined
  ) {
    value = t("dtwins.form.description.geolocation.attributes.latlong", {
      latitude: props.dtwin.features?.location?.reported?.latitude,
      longitude: props.dtwin.features?.location?.reported?.longitude,
    });
  }
  return value;
});
</script>

<template>
  <div class="p-4">
    <lxc-form-item :label="t('dtwins.form.description.idCard.attributes.type')">
      <lxc-input :value="modelLabel" type="text" read-only />
    </lxc-form-item>
    <lxc-form-item
      :label="t('dtwins.form.description.idCard.attributes.serialNumber')"
    >
      <lxc-input :value="dtwin.attributes.serialNumber" type="text" read-only />
    </lxc-form-item>
    <lxc-form-item :label="t('dtwins.form.description.state.attributes.state')">
      <lxc-input
        :value="
          dtwin.lifeCycleState
            ? t(`dtwins.lifeCycleState.${props.dtwin?.lifeCycleState}`)
            : NO_CONTENT
        "
        type="text"
        read-only
      />
    </lxc-form-item>
    <lxc-form-item
      :label="t('dtwins.form.description.state.attributes.lastConnection')"
    >
      <lxc-input
        :value="
          dtwin.lastConnectionDate
            ? formatIsoDate(props.dtwin.lastConnectionDate, dateFormat)
            : NO_CONTENT
        "
        type="text"
        read-only
      />
    </lxc-form-item>
    <lxc-form-item
      :label="t('dtwins.form.description.geolocation.attributes.address')"
    >
      <lxc-input
        :value="dtwin?.attributes?.address ?? NO_CONTENT"
        type="text"
        read-only
      />
    </lxc-form-item>
    <lxc-form-item
      :label="t('dtwins.form.description.geolocation.attributes.status')"
    >
      <lxc-input v-model="latLongRepresentation" type="text" read-only />
    </lxc-form-item>
    <lxc-button
      :title="t('button.validate')"
      @click="router.push({ name: PATH_DTWINS_ID, params: { id: dtwin.uid } })"
    >
      <div class="flex items-center">
        <span>{{
          t("dtwins.cartography.deviceMapTile.button.seeDevice")
        }}</span>
        <i-lxc-arrow-right-circle
          class="ml-2"
          width="1.25rem"
          height="1.25rem"
        />
      </div>
    </lxc-button>
  </div>
</template>
